import AuthenticationResource from '@ane/exp-data/lib/resources/AuthenticationResources';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
export const defaultReducerState = {
    res: getDefaultAsyncWrapperObj(),
};
// Action Types
const prefix = 'loadServicePrincipalNameList';
const CLEAR_DATA_SOURCE_STATE = `${prefix}/CLEAR_STATE`;
export const clearLoadServicePrincipalNameListState = () => ({
    type: CLEAR_DATA_SOURCE_STATE,
});
const loadServicePrincipalNameListArgs = {
    actionPrefix: `${prefix}/LOAD`,
    reduxKeyNested: () => ['res'],
    loadResource: (inputPayload) => {
        return AuthenticationResource.getServicePrincipalNameList(inputPayload.workspaceId);
    },
    onCompleteSuccess: (resourceResult) => {
        return resourceResult;
    },
};
export const loadServicePrincipalNameListEpicReducer = loadResourcesUtils(loadServicePrincipalNameListArgs);
// Reducer
export const loadServicePrincipalNameListReducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case CLEAR_DATA_SOURCE_STATE:
            return defaultReducerState;
        default:
            return loadServicePrincipalNameListEpicReducer.reduxChange(state, action);
    }
};
export default loadServicePrincipalNameListReducer;

//# sourceMappingURL=ServicePrincipalList.ducks.js.map
